import React from 'react';
import LeftNavigationModule
from '@thd-olt-component-react/etch-widgets/dist/components/etch2/components/LeftNavigationModule';
import mostViewedNavOpts from '../../../privacy/jsonData/leftNavOptions/MostViewed.json';
import shippingAndDeliveryOpts from '../../../privacy/jsonData/leftNavOptions/ShippingAndDeliveryOpts.json';
import productAndServicesOpts from '../../../privacy/jsonData/leftNavOptions/ProductAndServices.json';
import pricingAndPromosOpts from '../../../privacy/jsonData/leftNavOptions/PricingAndPromos.json';
import paymentsOpts from '../../../privacy/jsonData/leftNavOptions/paymentsOpts.json';
import myAccount from '../../../privacy/jsonData/leftNavOptions/MyAccountOpts.json';
import returnsAndRecallsOpts from '../../../privacy/jsonData/leftNavOptions/ReturnsAndRecallsOpts.json';
import policiesAndLegalOpts from '../../../privacy/jsonData/leftNavOptions/PoliciesAndLegalOpts.json';
import corporateInformationOpts from '../../../privacy/jsonData/leftNavOptions/CorporateInformationOpts.json';
import contactUsOpts from '../../../privacy/jsonData/leftNavOptions/ContactUsOpts.json';

export function LeftNav() {
  return (
    <div className="sui-pr-4">
      <LeftNavigationModule opts={mostViewedNavOpts} />
      <LeftNavigationModule opts={shippingAndDeliveryOpts} />
      <LeftNavigationModule opts={productAndServicesOpts} />
      <LeftNavigationModule opts={pricingAndPromosOpts} />
      <LeftNavigationModule opts={paymentsOpts} />
      <LeftNavigationModule opts={myAccount} />
      <LeftNavigationModule opts={returnsAndRecallsOpts} />
      <LeftNavigationModule opts={policiesAndLegalOpts} />
      <LeftNavigationModule opts={corporateInformationOpts} />
      <LeftNavigationModule opts={contactUsOpts} />
    </div>
  );
}
